<template>
  <div class="attr-list">
    <CommonAttr />
    <el-form>
      <el-form-item label="字体大小">
        <el-input-number v-model="curComponent.style.fontSize" />
      </el-form-item>
      <el-form-item label="字体颜色">
        <el-color-picker v-model="curComponent.style.color" />
      </el-form-item>
      <el-form-item label="背景颜色">
        <el-color-picker v-model="curComponent.style.background" show-alpha />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import CommonAttr from '../common/CommonAttr.vue'

export default {
  components: { CommonAttr },
  computed: {
    curComponent() {
      return this.$store.state.compose.curComponent
    }
  }
}
</script>
